import {
  MoneyV2,
  Product,
  ProductVariant as ProductVariantType,
} from '@shopify/hydrogen/storefront-api-types';
import {Money} from '@shopify/hydrogen';
import {CompareAtPrice} from '~/components';
import {isDiscounted} from '~/lib/utils';
import clsx from 'clsx';
import {ContentModalEntity} from '~/types/ContentModalEntity';
import ProductDetailHeader from './ProductDetailHeader';
import {DATA_TEST_IDS, QUERY_PARAM_KEYS} from '~/lib/const';

function ProductAddonCard({
  isActive,
  product,
  onClick,
}: {
  isActive: boolean;
  parentProductVariant?: ProductVariantType | null;
  product: Product;
  onClick: () => void;
}) {
  const currentVariant = product.variants?.nodes?.[0];
  const {priceV2: price, compareAtPriceV2: compareAtPrice} =
    currentVariant ?? {};

  if (currentVariant == null) {
    console.error("ProductAddonCard: addon product doesn't have variant.");
    return null;
  }

  return (
    <button
      data-testid={DATA_TEST_IDS.BUTTON('product-addon')}
      className={'w-full cursor-pointer'}
      type="button"
      onClick={onClick}
    >
      <div className="text-left">
        <span
          className={clsx(
            'float-right bg-gray-250 p-2 rounded-sm font-bold w-24 text-center text-sm',
            isActive && '!hidden',
          )}
        >
          + Add
        </span>
        <span
          className={clsx(
            'float-right hidden bg-gray-250 p-2 rounded-sm font-bold w-24 text-center text-sm',
            isActive && '!inline-block',
          )}
        >
          - Remove
        </span>
        <p className="text-base">{product.title}</p>
        <span className="text-base mt-1 font-medium">
          <Money withoutTrailingZeros data={price!} />
          {isDiscounted(price as MoneyV2, compareAtPrice as MoneyV2) && (
            <CompareAtPrice
              className={'ml-5 font-header text-16/20 font-bold text-gray-400'}
              data={compareAtPrice as MoneyV2}
            />
          )}
        </span>
      </div>
    </button>
  );
}

function ProductAddons({
  className,
  params,
  titles,
  products,
  productAddonModals,
  onClick,
}: {
  className?: string;
  params: URLSearchParams;
  titles?: string[];
  products: Product[];
  productAddonModals?: ContentModalEntity[];
  onClick: (index: number) => void;
}) {
  return (
    <>
      {products.map((product, index) => (
        <div key={product.handle} className={clsx('w-full', className)}>
          <ProductDetailHeader
            title={titles?.[index] ?? ''}
            data={productAddonModals?.[index]}
          />
          <ProductAddonCard
            // @ts-ignore
            product={product}
            isActive={params.get(`${QUERY_PARAM_KEYS.ADDON}-${index}`) === '1'}
            onClick={() => onClick(index)}
          />
        </div>
      ))}
    </>
  );
}

export default ProductAddons;
